
import Swiper from 'swiper/swiper-bundle.min'
import StoryBlokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'
import 'swiper/swiper-bundle.min.css'

export default {
  components: {
    StoryBlokComponent,
  },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      swiperInstance: null,
      offset: null,
    }
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.padding = this.getBreakpointValue(this.blok.padding)
      styles.margin = this.getBreakpointValue(this.blok.margin)

      return styles
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$gsap.context(() => {
        this.swiperInstance = new Swiper(this.$refs.swiperText, {
          loop: this.blok?.loop,
          // effect: 'cards',
          // cssMode: true,
          slidesPerView: 'auto',
          freeMode: true,
          spaceBetween: Number(this.blok?.spaceBetween) ?? 30,
          grabCursor: true,
          keyboard: true,
          mousewheel: {
            enabled: true,
            eventsTarget: this.$refs.swiperText,
            releaseOnEdges: true,
            thresholdDelta: 0.5,
            thresholdTime: 150,
            forceToAxis: true,
            invert: false,
            sensitivity: 0.5,
            modifiers: {
              axis: 'x',
              delta: 0.5,
              factor: 1,
              invert: false,
              pixelRatio: 1,
              velocity: 0.3,
            },
          },
          speed: 800,
          // autoplay: this.blok?.autoplay && {
          //   delay: 3000,
          //   disableOnInteraction: false,
          // },
          //   pagination: {
          //     el: '.swiper-pagination',
          //     clickable: true,
          //   },
          scrollbar: {
            el: this.$refs.scrollbar,
            hide: true,
          },
          // on: {
          //   realIndexChange: (swiper) => console.log(swiper.realIndex),
          //   init: () => console.log('init text'),
          // },
        })

        this.swiperInstance.on('mousewheel', (event) => {
          if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
            event.preventDefault()
            this.swiperInstance.translateTo(
              -this.swiperInstance.translate + event.deltaX * 2,
              0,
              0
            )
          }
        })
      }, this.$refs.container)
    })
  },
}
